export const enHeaderData = {
  home: "Home",
  about: "About",
  projects: "Projects",
  recommendations: "Feedback",
  contact: "Contact",
  goBack: "Back Home",
  smGoBack: "Back",
  toggleTheme: "Toggle theme",
  enLanguage: "English (GB)",
  ptLanguage: "Portuguese (BR)",
};

export const ptHeaderData = {
  home: "Home",
  about: "Sobre",
  projects: "Projetos",
  recommendations: "Feedback",
  contact: "Contato",
  goBack: "Voltar",
  smGoBack: "Voltar",
  toggleTheme: "Mudar tema",
  enLanguage: "Inglês (GB)",
  ptLanguage: "Português (BR)",
};
